/**
 * @module profile/components/portfolio
 */
import React, { Component, PropTypes } from 'react';
import Pager from 'common/containers/pager';
import PortfolioForm from 'profile/containers/portfolio/portfolio_form';
import PortfolioControls from 'profile/containers/portfolio/portfolio_controls';
import PortfolioGallery from 'profile/components/portfolio/portfolio_gallery';
import EntryDetails from 'profile/containers/portfolio/entry_details';
import MobileEntryDetails from 'profile/containers/portfolio/mobile_entry_details';
import { TABLET_BREAKPOINT_PX } from 'common/variables';
import { PortfolioMeta } from 'profile/containers/meta';
import { getCanonicalURL } from 'common/utils';

/**
 * Main portfolio view component
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class Portfolio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditForm: props.editForm.formOpen,
      entryToShow: null,
    };

    this.onPageChange = this.onPageChange.bind(this);
    this.toggleEntryDetails = this.toggleEntryDetails.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  onPageChange(page) {
    const offset = this.props.portfolioState.pageSize * (page - 1);
    this.props.fetchPortfolioEntries(this.props.profileUsername, offset);
  }

  fetchData(onlyEntries) {
    const { profileUsername } = this.props;

    if (onlyEntries) {
      this.props.fetchPortfolioEntries(profileUsername);
    } else {
      this.props.fetchPortfolioEntriesIfNeeded(profileUsername);
    }
  }

  toggleEntryDetails(entryId) {
    if (window.innerWidth > TABLET_BREAKPOINT_PX) {
      this.props.toggleCollapsed();
    }

    const valuesToSet = {
      entryToShow: this.props.portfolioState.entriesById[entryId],
    };

    this.setState({ ...valuesToSet });
    this.props.toggleDetailsMode();
  }

  render() {
    const { portfolioState, visibleEntries, user, profileUsername, profile,
      setPortfolioDirty, deletePortfolio } = this.props;
    const userAccess = {
      userType: user.profile_data ? user.profile_data.user_type : 'anonymous',
      isOwner: false,
    };

    if (user.logged_in && user.profile_data) {
      userAccess.isOwner = profileUsername === user.profile_data.username;
    }

    return (
      <section className="row portfolio-section">
        <PortfolioMeta />
        { portfolioState.editMode &&
        <div className="large-12 columns portfolio-edit-buttons">
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={this.props.togglePortfolioEditForm}
          >
            Add New
          </button>
          {/*
          <span className="reorder-info">
            <i className="fa fa-arrows" aria-hidden="true" />
              Drag to Reorder
          </span> */}
        </div>
        }
        <div className="small-16 columns portfolio-wrapper">
          <div className="row portfolio-content">
            <div className="small-16 large-12 column">
              <PortfolioGallery
                profileUsername={profileUsername}
                items={visibleEntries}
                reorderedEntries={portfolioState.reorderedEntries}
                userAccess={userAccess}
                editMode={portfolioState.editMode}
                onToggleEntryDetails={this.toggleEntryDetails}
                onSetPortfolioDirty={setPortfolioDirty}
                onDeleteEntry={deletePortfolio}
              />
            </div>
            <div className="show-for-large large-4 columns">
              <aside className="sidebar">
                <PortfolioControls />
              </aside>
            </div>
          </div>
          { portfolioState.detailsMode &&
            <div className="hide-for-large">
              <MobileEntryDetails
                creative={profile}
                profileUsername={profileUsername}
                userAccess={userAccess}
                entry={this.state.entryToShow}
                toggleEntryDetails={this.toggleEntryDetails}
              />
            </div>
          }
          { portfolioState.detailsMode &&
            <div className="show-for-large">
              <EntryDetails
                creative={profile}
                profileUsername={profileUsername}
                userAccess={userAccess}
                entry={this.state.entryToShow}
                visibleEntries={visibleEntries}
                toggleEntryDetails={this.toggleEntryDetails}
              />
            </div>
          }
          { (!portfolioState.editMode && portfolioState.pageCount > 1) &&
            <div className="portfolio-gallery-pagination">
              <div className="row">
                <div className="columns medium-12">
                  <Pager
                    pageCount={portfolioState.pageCount}
                    currentPage={portfolioState.currentPage}
                    onPageChange={this.onPageChange}
                  />
                </div>
              </div>
            </div>
          }
        </div>
        <PortfolioForm />
      </section>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {string} profileUsername - username of the user profile being viewed
 * @property {object} portfolioState - view data, page etc
 * @property {object} profile - user profile data
 * @property {object} user - currently logged-in user
 * @property {object} editForm - portfolio form data, used to check if it's visible
 * @property {array} visibleEntries - array of entries to show
 * @property {func} toggleCollapsed - function to collapse header when single entry is visible
 * @property {func} togglePortfolioEditForm - toggle new portfolio entry form
 * @property {func} fetchPortfolioEntries - get user's portfolio objects
 * @property {func} fetchPortfolioEntriesIfNeeded - get user's portfolio objects
 * @property {func} setPortfolioDirty - function called when portfolio ordering changes
 * @property {func} deletePortfolio - function to delete portfolio entry
 */
Portfolio.propTypes = {
  profileUsername: PropTypes.string,
  portfolioState: PropTypes.object,
  profile: PropTypes.object,
  user: PropTypes.object,
  editForm: PropTypes.object,
  visibleEntries: PropTypes.array,
  toggleDetailsMode: PropTypes.func,
  toggleCollapsed: PropTypes.func,
  togglePortfolioEditForm: PropTypes.func,
  fetchPortfolioEntries: PropTypes.func,
  fetchPortfolioEntriesIfNeeded: PropTypes.func,
  setPortfolioDirty: PropTypes.func,
  deletePortfolio: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio.jsx